import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {menuButton} from "../../../utils/styles";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    ...menuButton(theme)
}));

export default function MenuButtonSimpleLink(props) {
    const { label, selected, to, icon, ...rest } = props;
    const classes = useStyles();

    return (
        <Button
            className={clsx(classes.textButton, classes.menuButton, selected && 'selected')}
            startIcon={icon}
            component={Link}
            to={to}
            {...rest}>
            {label}
        </Button>
    );
};

MenuButtonSimpleLink.propTypes = {
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    to: PropTypes.string.isRequired,
    icon: PropTypes.element
};